import React from 'react';
import styled from '@emotion/styled';
import Heading from '~ComponentsImproved/Typography/Heading';

const Statusbar = styled.div`
  height: 24px;
  width: 100vw;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  background-color: var(--colorBlueGray1300);
  position: fixed;
  left: 0;
  top: 0;
`;

interface Props {
  text: string;
}

const DeviceStatusbar = ({ text }: Props) => {
  return (
    <Statusbar>
      <Heading level={6} color={'var(--colorBlueGray600)'}>
        {text}
      </Heading>
    </Statusbar>
  );
};

export default DeviceStatusbar;
